/**
 * Course Structure Data
 * Defines the complete A-Z Heat Pump Course table of contents
 */

import {
  ExperimentOutlined,
  ApartmentOutlined,
  FileSearchOutlined,
} from '@ant-design/icons';

export const courseStructure = [
  {
    id: 'cold-room',
    number: '1',
    title: 'Cold Room',
    icon: <ExperimentOutlined />,
    description: 'Understanding thermal dynamics in unheated spaces and heat loss mechanisms.',
    subsections: [
      { id: '1.1', title: 'Heat Loss', link: '/az-course/heat-loss', description: 'Fundamentals of thermal energy dissipation through building envelope.' },
      { id: '1.2', title: 'Building U-Value', link: '/az-course/u-value', description: 'Thermal transmittance coefficient and its calculation methods.' },
      { id: '1.3', title: 'Ventilation', link: '/az-course/ventilation', description: 'Air exchange rates and their impact on thermal balance.' },
      { id: '1.4', title: 'Neighboring Rooms Heating Input', link: '/az-course/neighboring-rooms', description: 'Heat transfer between adjacent spaces and its quantification.' }
    ]
  },
  {
    id: 'heat-input',
    number: '2',
    title: 'Heat Input',
    icon: <ApartmentOutlined />,
    description: 'Comprehensive analysis of heat generation, distribution, and system performance optimization.',
    subsections: [
      { id: '2.1', title: 'Heat Generation and Heat Transfer', link: '/az-course/heat-generation', description: 'Principles of thermal energy production and conduction mechanisms.' },
      { id: '2.2', title: 'Role of Supply Temperature', link: '/az-course/supply-temperature', description: 'Impact of flow temperature on system efficiency and comfort.' },
      { id: '2.3', title: 'Influence of System Temperatures', link: '/az-course/system-temperatures', description: 'Delta-T analysis and temperature differential optimization.' },
      { id: '2.4', title: 'Coefficient of Performance (COP)', link: '/az-course/cop', description: 'Efficiency metric definition, calculation, and optimization strategies.' },
      { id: '2.5', title: 'Changes in Building U-Value', link: '/az-course/u-value-changes', description: 'Effects of insulation improvements and building modifications.' },
      { id: '2.6', title: 'Radiator Transfer Coefficient', link: '/az-course/radiator-coefficient', description: 'Heat transfer parameters and their influence on output.' },
      { id: '2.7', title: 'Radiator Dimensioning', link: '/az-course/radiator-dimensioning', description: 'Sizing methodology and selection criteria for heating elements.' },
      { id: '2.8', title: 'Pipes and Valves', link: '/az-course/pipes-valves', description: 'Hydraulic components, pressure drops, and flow regulation.' },
      { id: '2.9', title: 'Pump Pressure', link: '/az-course/pump-pressure', description: 'Head calculation, pump curves, and system integration.' }
    ]
  },
  {
    id: 'two-room-scenarios',
    number: '3',
    title: 'Two Room Scenarios',
    icon: <ApartmentOutlined />,
    description: 'Practical multi-zone analysis and balancing techniques for interconnected spaces.',
    subsections: [
      { id: '3.1', title: 'Symmetric Case', link: '/az-course/symmetric-case', description: 'Baseline analysis with identical room configurations.' },
      { id: '3.2', title: 'Changing Pre-set Valve Opening', link: '/az-course/valve-opening', description: 'Flow regulation effects and balancing adjustments.' },
      { id: '3.3', title: 'Changing Radiator Size', link: '/az-course/radiator-size', description: 'Impact of heating surface modifications on system balance.' },
      { id: '3.4', title: 'Low / High Pressure Setting', link: '/az-course/pressure-settings', description: 'System pressure optimization and performance implications.' }
    ]
  },
  {
    id: 'case-studies',
    number: '4',
    title: 'Case Studies',
    icon: <FileSearchOutlined />,
    description: 'Real-world applications, troubleshooting scenarios, and practical solutions.',
    subsections: [
      { id: '4.1', title: 'Historic Buildings: Old vs. Renovated', link: '/az-course/historic-buildings', description: 'Comparative analysis of heritage structures before and after retrofit.' },
      { id: '4.2', title: 'System Noise', link: '/az-course/system-noise', description: 'Causes, diagnostic procedures, and maintenance solutions.' },
      { id: '4.3', title: 'Low COP with Adequate Heating', link: '/az-course/low-cop-case', description: 'Investigating efficiency issues when comfort targets are met.' },
      { id: '4.4', title: 'Excessive Supply Temperature', link: '/az-course/high-supply-temp', description: 'Diagnosing and correcting oversized temperature settings.' }
    ]
  }
];
